import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FormTitle from '@src/mobile/layout/Component/FormTitle';
import FormSmallTitle from '@src/mobile/layout/Component/FormSmallTitle';
import FormInput from '@src/mobile/layout/Component/FormInput';
import UploadVideo from './UploadVideo';
import UploadPic from './UploadPic';

const Media = ({ formData, setFormDataHandle, warningTextList, updateId, updateSuccess }) => {
    
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.media}>
            <FormTitle name="img" title="形象照片" warningText={warningTextList['img']} isRequired={true} />
            <div className={styles.picInfo}>请上传面貌清晰的半身、全身各一张，图片仅支持JPEG、PNG、GIF、JPG格式 </div>
            <div className={styles.picList}>
                <UploadPic name="img1" num={1} formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} />
                <UploadPic name="img2" num={2} formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} />
            </div>
            <FormTitle name="info1" title="请填写你身上令人印象深刻的三个特点" warningText={warningTextList['info1']} isRequired={true} />
            <FormInput name="info1" formData={formData} changeInputHandle={changeInputHandle} />
            <FormTitle name="info2" title="一句话喊出你的参赛宣言" warningText={warningTextList['info2']} isRequired={true} />
            <FormInput name="info2" formData={formData} changeInputHandle={changeInputHandle} />
            <FormTitle name="video_self" title="视频作品（选填）" warningText={warningTextList['video_self']} isRequired={true} />
            <div className={styles.picInfo}>
                <p className={styles.t0}>个人风采展示</p>
                <p className={styles.t1} >拍摄一段30-90s的主题短视频，令人深刻的自我介绍，可进行个人才艺表演等。</p>
                <p>视频内容要求：才艺表演类，个人特长展示类均可，形式不限，不使用美颜、 不使用滤镜，视频为竖屏比例为9： 16，分辨率1080x1920PX视频仅支持MP4、MOV、GUICKTIME 格式。</p>
            </div>
            <UploadVideo name="video_self" formData={formData} changeInputHandle={changeInputHandle} />
            <div className={styles.socialTitle}>个人社交媒体账号情况收集</div>
            <FormSmallTitle name="socialAccount" title="是否有经营个人社交媒体账号？" warningText={warningTextList['socialAccount']} isRequired={true} />
            <FormInput name="socialAccount" formData={formData} placeholder="如果有，请附上账号主页链接，如没有，填“无”" changeInputHandle={changeInputHandle} />
            <FormSmallTitle name="satisfiedPlatform" title="自己最满意的社交媒体账号位于哪个平台？并请简述账号定位" warningText={warningTextList['accountPlatform']} isRequired={true} />
            <FormInput name="satisfiedPlatform" formData={formData} placeholder="展示脑洞大开的你吧~没有的话也没关系，可以填“无”" changeInputHandle={changeInputHandle} />
            <FormSmallTitle name="videoLink" title="填写个人最满意的短视频作品链接" warningText={warningTextList['info1']} isRequired={true} />
            <FormInput name="videoLink" formData={formData} placeholder="展示灵感迸发的你吧~没有的话也没关系，可以填“无”" changeInputHandle={changeInputHandle} />
        </div>
    );
};

Media.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateId: PropTypes.string,
    updateSuccess: PropTypes.bool
};

export default errorBoundary(Media);
